import { queryOptions } from '@tanstack/react-query'
import type { MessageTemplate, TemplateInput, TemplateListResponse } from '@/types/templateTypes'

// Shared message templates. Rarely change, so no polling — the manage dialog
// invalidates ['templates'] after every write.
export const templatesQueryOptions = () =>
  queryOptions({
    queryKey: ['templates'],
    queryFn: async (): Promise<TemplateListResponse> => {
      const response = await fetch('/api/templates')
      if (!response.ok) {
        throw new Error('Failed to fetch templates')
      }
      return response.json()
    },
    staleTime: 60_000,
  })

async function unwrap(response: Response, fallback: string) {
  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.error || fallback)
  }
  return response.json()
}

export const createTemplate = async (data: TemplateInput): Promise<MessageTemplate> =>
  unwrap(
    await fetch('/api/templates', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }),
    'Failed to create template',
  )

export const updateTemplate = async (
  id: string,
  data: TemplateInput,
): Promise<MessageTemplate> =>
  unwrap(
    await fetch(`/api/templates/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }),
    'Failed to update template',
  )

export const deleteTemplate = async (id: string): Promise<void> => {
  const response = await fetch(`/api/templates/${id}`, { method: 'DELETE' })
  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.error || 'Failed to delete template')
  }
}
